<template>
    <section style="margin:18px;">
        <v-layout row xs3 style="border-bottom: 1px solid lightgrey;">
            <v-flex xs2  style="padding: 22px;font-size: 16px;font-weight: bold;">Filter : </v-flex>
            <v-flex xs3>
                <v-select v-on:change="GetForumData" item-value='_id' item-text='name' return-object :items="GetCourseList" label="Filter Based On Course Category">
                        <template slot='selection' slot-scope='{ item }'>
                            {{ item.Course_Category_Name }}
                        </template>
                        <template slot='item' slot-scope='{ item }'>
                            {{ item.Course_Category_Name }}    
                        </template>
                </v-select>
            </v-flex>
        </v-layout>
        <section v-if="GetFourm.length > 0" style="margin:8px;">
            <v-card class="ribbon-box mx-auto" style="margin: 10px;" max-width="900" v-for="(forum,index) in GetFourm" :key="index">
                <span v-if="forum.Status" class="ribbon"></span>
                <v-card-text class="ribbon-box-inside">
                    <v-card-title style="font-size: 22px;font-weight: 400;">{{ forum.Question }}</v-card-title>
                    <v-flex class="TextDescription">Course : {{ forum.Course_Title }}</v-flex>
                    <v-flex style="cursor: pointer;text-align: right;padding-top: 10px;font-weight: bold;" @click="OpenForumDetails(forum)">Read More</v-flex>
                </v-card-text>
            </v-card>
            <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
        </section>
        <section v-else style="margin:8px;">
            <v-card class="ribbon-box mx-auto" max-width="900">
                <v-card-text class="ribbon-box-inside">
                    <div style="text-align: center;color: #8080805e;font-size: 26px;padding: 12%;">
                        <div>Its empty in here</div>
                        <div>Oops! Seems like there's nothing</div>
                    </div>
                </v-card-text>
            </v-card>
        </section>
        <app-update-forum ref="UpdateForum" :dialog='UpdateForum' @close='CloseDialog'></app-update-forum>
    </section>
</template>
<script>
  import appUpdateForum from '../views/dialogs/UpdateForum'
export default {
    components:{
        appUpdateForum
    },
    data(){
        return {
            UpdateForum  : false,
            pages       : 1,
            records     : 0,
        }
    },
    computed: {
        GetCourseList() {
            return this.$store.getters.GetCourseList;
        },
        GetFourm(){

            return this.$store.getters.GetFourm
        }
    },
    methods:{
        OpenForumDetails(Details){
            this.UpdateForum = true
            this.$refs.UpdateForum.GetForumDetails(Details)
        },
        CloseDialog(){
            this.UpdateForum = false
        },
        GetForumData(CourseCategory){
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/courseforum/filterforumdata`,{ "Course_CategoryId" : CourseCategory['_id'] })
                .then(response => {
                    
                    this.$store.commit("SetFourm", response["data"]["response"]);
                })
                .catch(err => {

                    this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                });

        },
        GetNextSetOfData(){

            this.$http.post(`${this.$store.getters.GetProductionUrl}/courseforum/getcourseforum`,{'limit' : 10, 'page' : this.pages })
                      .then(response => {
                    
                        this.$store.commit("SetFourm", response["data"]["response"]);
                        this.records = response["data"]["Records"] ? response["data"]["Records"] : 0
                        this.$eventHub.$emit("LOADING",'false')
                      })
                      .catch(err => {
                        this.$eventHub.$emit("LOADING",'false')
                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                     });
        }
    },
    mounted() {

        this.$http.get(`${this.$store.getters.GetProductionUrl}/course/getcourselist`)
                .then(response => {

                    this.$store.commit("SetCourseList", response["data"]["response"]);
                    this.GetNextSetOfData()

                })
                .catch(err => {

                    this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                });
    }
}
</script>
<style >
.TextDescription{
    font-size: 16px;
    font-weight: 300;
    display: -webkit-box;
    -webkit-line-clamp: 2   ;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: justify;
    margin: 0px 20px;
}
.ribbon-box .ribbon {
    display: inline-block;
    position: absolute;
    left: 20px;
    top: 38px;
}
 .ribbon-box .ribbon:before,
 .ribbon-box .ribbon:after {
    content: "";
    display: block;
    position: absolute;
    height: 10px;
    bottom: 4px;
    border: 12px solid #53b0de;
    right: -3px;
 }
 .ribbon-box .ribbon:before {
    border-right-color: transparent;
    bottom: 4px;
    right: -16px;
 }
 .VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
</style>